<app-alert></app-alert>
<app-loader></app-loader>
<app-header *ngIf="isAuthenticated()"></app-header>
<router-outlet></router-outlet>
